import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { OfferStoreContext } from "@gp/components";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

export const BetBoosterSubHeaderButton = observer(
	function BetBoosterSubHeaderButton(props: {
		subHeaderType: {
			abrv: "bet-builder" | "betting-tips";
			name: string;
		};
	}) {
		const { t } = useTranslation();
		const { subHeaderType } = props;
		const isBetBuilder = subHeaderType.abrv === "bet-builder";
		const isBettingTips = subHeaderType.abrv === "betting-tips";

		const offerStore = useContext(OfferStoreContext) as
			| EventViewStore
			| AdditionalOfferViewStore;

		return (
			<button
				className={classNames(
					"tabs__item tabs--boxed__item tabs--scroll__item",
					{
						"is-active":
							offerStore.activeSubGroup === subHeaderType.abrv,
					}
				)}
				onClick={() => {
					offerStore.setActiveSubGroup(subHeaderType.abrv);
				}}
				type="button"
			>
				{isBetBuilder && (
					<i className="tabs__frame tabs--boxed__frame u-icon u-icon--sml u-icon--bb--active" />
				)}
				{isBettingTips && (
					<i className="tabs__frame tabs--boxed__frame u-icon u-icon--sml u-icon--betting-tip--str u-color--bet--returned" />
				)}
				<span className="tabs__title tabs--boxed__title">
					{subHeaderType.name}
				</span>
				{isBettingTips && (
					<span className="tabs__tag tag tag--tny tag--bolder">
						{t<string>("CASINO.NEW_GAME_LABEL")}
					</span>
				)}
			</button>
		);
	}
);
